import { render, staticRenderFns } from "./LabSimpleSynthesis.vue?vue&type=template&id=5bfb19c0&"
import script from "./LabSimpleSynthesis.vue?vue&type=script&lang=ts&"
export * from "./LabSimpleSynthesis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports